import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers/rootReducer";
import { createLogger } from "redux-logger";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
};

const logger = createLogger({
  // ...options
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const saga = createSagaMiddleware();

const store = createStore(persistedReducer, applyMiddleware(saga, logger));

export default store;
export const persistor = persistStore(store);
